import React from 'react';
import Chip from '@material-ui/core/Chip';

function ContentTwo() {
  return (
    <div>
      <h1>
        I'm a Front-End developer currently focusing on Progressive Web Apps and
        JavaScript ecosystem.{' '}
      </h1>
      <div className="chips">
        <Chip size="large" label="Javascript" />
        <Chip size="large" label="Typescript" />
        <Chip size="large" label="Angular" />
        <Chip size="large" label="React" />
        <Chip size="large" label="Redux" />
        <Chip size="large" label="Ionic" />
        <Chip size="large" label="Bootstrap" />
        <Chip size="large" label="HTML5" />
        <Chip size="large" label="CSS3" />
        <Chip size="large" label="SASS" />
        <Chip size="large" label="Jquery" />
        <Chip size="large" label="Node.js" />
        <Chip size="large" label="Git" />
        <Chip size="large" label="Firebase" />
      </div>
    </div>
  );
}

export default ContentTwo;
